import React from 'react';
import axios from 'axios';
import { get } from 'lodash';
import { toast } from 'react-toastify';
import { withRouter } from 'react-router-dom';
import { FieldSet, Spinner } from '../elements';
import { Documents } from '../components';
import { API_URL } from '../../lib/const';
import {
  PAYMENT_STATUS,
  PAYMENT_METHOD,
  ENROLLMENT_STATUS,
} from '../../lib/config';
import ComponentWithToken from '../components/CompontentWithToken';
import DownloadButton from '../components/DownloadButton';
import {
  fetchFinanceDataSummary,
  fetchPaymentPlans,
  regenerateOverdueBoleto,
} from '../services/finance_data_service';
import IconBoleto from '../../assets/img/boleto.png';
import IconPix from '../../assets/img/pix.png';
import IconCartao from '../../assets/img/cartao.png';
import CreditCardPaymentForm from './CreditCardPaymentForm';
import { ButtonStyle } from '../../assets/css/components/ButtonStyle';
import { getCardFlag } from '../../lib/utils';
import ListStudentBoleto from '../components/boleto/ListStudentBoleto';

class Payment extends ComponentWithToken {
  state = {
    loading: false,
    status: null,
    invoices: [],
    proofs_of_payment: [],
    boleto_id: null,
    onboardingPaymentMethods: [],
    ProofSent: true,
    complementaryBoletos: [],
    financePlan: {},
    planValue: 0,
    creditCardValue: 0,
    installments: 1,
    gratuity: null,
    redirectUrl: null,
    safe2payIconConfig: { habilitar_pix: true, habilitar_cartao: true, habilitar_boleto: false },
    loadingPayment: null,
    paymentPlans: [],
    paymentStatusId: null,
  };

  componentDidMount() {
    Promise.all([
      this.fetchStatus(),
      this.fetchFinanceData(),
      this.fetComplementaryBoletos(),
      this.fetchSafe2PayIconConfig(),
      fetchPaymentPlans(this.token).then((plans) => this.setState({ paymentPlans: plans })).catch(() => {}),
    ]).finally(() => this.setState({ loading: false }));
  }

  fetchSafe2PayIconConfig = () =>
    axios
      .get(`${API_URL}/finance/safe2pay-icon-config`)
      .then((response) => this.setState({ safe2payIconConfig: response.data }))
      .catch(() => {});

  fetComplementaryBoletos = () => {
    axios
      .get(`${API_URL}/onboarding/complementary-boletos/${this.token}`)
      .then((response) =>
        this.setState({ complementaryBoletos: response.data })
      );
  };

  fetchStatus() {
    this.setState({ loading: true });
    return axios
      .get(`${API_URL}/onboarding/enroll/${this.token}`)
      .then((response) =>
        this.setState({
          status: get(response, 'data.enrollment_status'),
          envelopeStatus: get(response, 'data.envelope_status'),
          showProof: get(response, 'data.show_proof'),
          isCourseExempt: get(response, 'data.is_course_exempt'),
          ProofSent: get(response, 'data.proof_sent'),
          gratuity: get(response, 'data.gratuity'),
          paymentStatusId: get(response, 'data.payment_status_id'),
        })
      );
  }

  fetchFinanceData = () =>
    fetchFinanceDataSummary(this.token).then((response) =>
      this.setState({
        financePlan: get(response, 'plan'),
        boleto_id: get(response, 'boleto_id'),
        planValue: get(response, 'plan_value'),
        creditCardValue: get(response, 'credit_card_value'),
        onboardingPaymentMethods: get(response, 'onboarding_payment_methods'),
        transactionStatus: get(response, 'transaction_status'),
        installments: get(response, 'credit_card_installments'),
      })
    );

  handleDocumentUpload = (event) => {
    const file = get(event, 'target.files.0');
    const data = new FormData();
    data.append('file', file);
    data.append('document_type', 6);
    return axios
      .post(`${API_URL}/uploads/`, data, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((response) => {
        this.setState((prevState) => {
          const { proofs_of_payment } = prevState;
          proofs_of_payment.push({ key: response.data.key, name: file.name });
          return { proofs_of_payment };
        });
      });
  };

  handleProofOfPaymentRemove = (key) => {
    const { proofs_of_payment } = this.state;
    const new_proofs_of_payment = proofs_of_payment.filter(
      (proof) => proof.key !== key
    );
    this.setState({ proofs_of_payment: new_proofs_of_payment });
  };

  handleSend() {
    const { proofs_of_payment } = this.state;
    const { token } = this.props;
    this.setState({ loading: true });
    const data = {
      proofs_of_payment,
    };

    axios
      .post(`${API_URL}/onboarding/proof-of-payment/${token}`, data)
      .then(() => {
        toast.success('Comprovante de pagamento enviado', {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
        this.componentDidMount();
      })
      .catch((error) => {
        toast.error(
          get(error, 'response.data[0]', 'Ocorreu um erro inesperado'),
          { position: toast.POSITION.BOTTOM_RIGHT }
        );
        this.setState({
          loading: false,
        });
      });
  }

  renderComprovantePagamento() {
    const { proofs_of_payment } = this.state;
    return (
      <>
        <div
          className="documents-base row"
          style={{ justifyContent: 'flex-start' }}
        >
          <Documents
            id="Comprovante de pagamento"
            label="Comprovante de pagamento"
            onUpload={this.handleDocumentUpload}
            onRemove={this.handleProofOfPaymentRemove}
            documents={proofs_of_payment}
          />
        </div>
        <ButtonStyle
          className="mt-2"
          onClick={() => this.handleSend()}
          type="button"
        >
          ENVIAR
        </ButtonStyle>
        <hr />
      </>
    );
  }

  renderDownloadContract() {
    return (
      <>
        <FieldSet title="Contrato" />
        <DownloadButton
          href={`${API_URL}/contracts/enrollment/${this.token}/contract`}
          label="Baixar contrato"
        />
        <div className="row mb-3 mt-3">
          <div className="col-sm-12 mt-3">
            <label>
              Para assinar o contrato digitalmente busque no seu provedor de
              e-mail pelo contrato enviado pela DocuSign.
            </label>
          </div>
        </div>
      </>
    );
  }

  generateBoleto = () => {
    regenerateOverdueBoleto(this.token).then((d) => {
      this.setState({ boleto_id: d.boleto_id });
      toast.success('Boleto gerado com sucesso!');
    });
  };

  generateSafeToPay = (token, paymentMethod) => {
    if (this.state.loadingPayment) return;

    if (this.state.paymentStatusId === PAYMENT_STATUS.PAYMENT_CONFIRMED) {
      toast.info('Pagamento já realizado, favor anexar o comprovante de pagamento.');
      return;
    }

    const PAYMENT_METHOD_CODE = { boleto: '1', credit_card: '2', pix: '6' };
    const paymentMethodCode = PAYMENT_METHOD_CODE[paymentMethod];

    const matriculaPlan = this.state.paymentPlans.find((p) => p.type === 1);
    if (!matriculaPlan) {
      toast.error('Parcela de matrícula não encontrada. Tente novamente mais tarde.');
      return;
    }

    this.setState({ loadingPayment: paymentMethod });

    const toastId = toast.info(
      'Aguarde, estamos preparando tudo para processar seu pagamento. Caso a aba de pagamento não abra, habilite pop-ups no seu navegador.',
      { autoClose: false, closeOnClick: false, draggable: false }
    );

    axios
      .post(`${API_URL}/finance/payment-plan-link/${token}`, {
        payment_plan_id: matriculaPlan.id,
        payment_method_code: paymentMethodCode,
      })
      .then((response) => {
        toast.dismiss(toastId);
        const url = response.data.checkout_url;
        this.setState({ redirectUrl: url });
        window.open(url, '_blank', 'noopener,noreferrer');
        toast.success('Link de pagamento criado com sucesso!', { position: toast.POSITION.BOTTOM_RIGHT });
      })
      .catch((err) => {
        toast.dismiss(toastId);
        toast.error(
          get(err, 'response.data.error', 'Não foi possível criar o link de pagamento. Tente novamente.')
        );
      })
      .finally(() => {
        this.setState({ loadingPayment: null });
      });
  };

  renderSafeToPayPaymentSection() {
    const { safe2payIconConfig } = this.state;
    const allOptions = [
      { label: 'Pix', icon: IconPix, method: 'pix', enabled: safe2payIconConfig.habilitar_pix },
      { label: 'Cartão de crédito', icon: IconCartao, method: 'credit_card', enabled: safe2payIconConfig.habilitar_cartao },
      { label: 'Boleto', icon: IconBoleto, method: 'boleto', enabled: safe2payIconConfig.habilitar_boleto },
    ];
    const paymentOptions = allOptions.filter((o) => o.enabled);

    if (paymentOptions.length === 0) {
      return (
        <>
          <FieldSet title="Pagamento" />
          <div
            style={{
              marginBottom: '16px',
              padding: '16px',
              border: '1px solid #ddd',
              borderRadius: '8px',
              background: '#fff8e1',
              color: '#8a6d3b',
            }}
          >
            Nenhuma forma de pagamento via Safe2Pay está disponível no momento. Tente novamente mais tarde ou entre em contato com o suporte.
          </div>
          <hr />
        </>
      );
    }
    const { loadingPayment } = this.state;
    return (
      <>
        <FieldSet title="Pagamento" />
        <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap', marginBottom: '16px' }}>
          {paymentOptions.map(({ label, icon, method }) => {
            const isActive = loadingPayment === method;
            const isDisabled = !!loadingPayment;
            return (
              <button
                key={method}
                onClick={() => this.generateSafeToPay(this.token, method)}
                disabled={isDisabled}
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '8px',
                  padding: '16px 24px',
                  border: '1px solid #ddd',
                  borderRadius: '8px',
                  background: '#fff',
                  cursor: isDisabled ? 'not-allowed' : 'pointer',
                  boxShadow: '0px 2px 4px rgba(0,0,0,0.08)',
                  minWidth: '120px',
                  opacity: isDisabled && !isActive ? 0.5 : 1,
                }}
                type="button"
              >
                {isActive ? (
                  <span
                    style={{
                      width: '48px',
                      height: '48px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    <span
                      style={{
                        width: '28px',
                        height: '28px',
                        border: '3px solid #ddd',
                        borderTop: '3px solid #333',
                        borderRadius: '50%',
                        display: 'inline-block',
                        animation: 'spin 0.8s linear infinite',
                      }}
                    />
                  </span>
                ) : (
                  <img src={icon} alt={label} style={{ width: '48px', height: '48px', objectFit: 'contain' }} />
                )}
                <span style={{ fontSize: '13px', fontWeight: 500 }}>{label}</span>
              </button>
            );
          })}
        </div>
        <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
        <hr />
      </>
    );
  }

  renderBoletoPaymentSection() {
    const { boleto_id, complementaryBoletos, financePlan, gratuity } =
      this.state;
    const { user_can_generate_boleto } = financePlan;
    return (
      <ListStudentBoleto
        boleto={boleto_id}
        complementaryBoletos={complementaryBoletos}
        userCanGenerateBoletos={user_can_generate_boleto}
        onResubmit={this.generateBoleto}
        gratuity={gratuity}
      />
    );
  }

  isEnrollmentPaid = () => {
    const { transactionStatus, ProofSent, paymentStatusId } = this.state;
    const transactionStatusId = get(transactionStatus, 'id');
    return (
      transactionStatusId === PAYMENT_STATUS.PAYMENT_CONFIRMED ||
      ProofSent ||
      paymentStatusId === PAYMENT_STATUS.EXEMPT ||
      paymentStatusId === PAYMENT_STATUS.PAYMENT_CONFIRMED
    );
  };

  onCreditCardPay = (paymentInfo) => {
    const payload = {
      ...paymentInfo,
      card_brand: getCardFlag(paymentInfo.card_number),
    };
    return axios
      .post(
        `${API_URL}/payment-gateway/enrollment-transaction/${this.token}`,
        payload
      )
      .then((response) => {
        if (response.data.status === PAYMENT_STATUS.CREDIT_CARD_ERROR) {
          toast.error(
            `Erro:${get(
              response,
              'data.message',
              'Ocorreu um erro inesperado!'
            )}`
          );
        }

        if (response.data.status === PAYMENT_STATUS.PAYMENT_CONFIRMED) {
          toast.success('Pagamento aprovado!');
          this.componentDidMount();
        }
      })
      .catch((err) => {
        toast.error('Ocorreu um erro inesperado!');
      });
  };

  renderPaymentMethodsSection = () => {
    const {
      onboardingPaymentMethods,
      creditCardValue,
      ProofSent,
      installments,
    } = this.state;

    const showSafeToPayPayment = !!onboardingPaymentMethods.filter(
      (e) => e.id === PAYMENT_METHOD.SAFE_TO_PAY
    ).length;
    const showCreditCardPayment = !!onboardingPaymentMethods.filter(
      (e) => e.id === PAYMENT_METHOD.CREDIT_CARD
    ).length;
    const showBoletoPayment = !!onboardingPaymentMethods.filter(
      (e) => e.id === PAYMENT_METHOD.BOLETO_INSTITUTION
    ).length;

    return (
      <>
        {showSafeToPayPayment && this.renderSafeToPayPaymentSection()}
        {showBoletoPayment && this.renderBoletoPaymentSection()}
        {!ProofSent &&
          (showBoletoPayment || !showSafeToPayPayment) &&
          this.renderComprovantePagamento()}
        {showCreditCardPayment && (
          <CreditCardPaymentForm
            onPay={this.onCreditCardPay}
            amount={creditCardValue}
            installments={installments}
          />
        )}
      </>
    );
  };

  render() {
    const { loading, status, transactionStatus, showProof, isCourseExempt, paymentStatusId } = this.state;
    const { backClick } = this.props;
    const isEnrollmentPaid = this.isEnrollmentPaid();
    const isExempt = showProof === false || isCourseExempt || paymentStatusId === PAYMENT_STATUS.EXEMPT;

    return (
      <Spinner active={loading}>
        {isExempt && (
          <div className="row mb-3 mt-3">
            <div className="col-sm-12 mt-3">
              <label>Esta matrícula possui isenção de pagamento.</label>
            </div>
          </div>
        )}
        {!isExempt &&
          !isEnrollmentPaid &&
          (status === ENROLLMENT_STATUS.WAITING_PAYMENT ||
            status == ENROLLMENT_STATUS.REVIEWING) &&
          this.renderPaymentMethodsSection()}
        {!isExempt && isEnrollmentPaid && (
          <div className="row mb-3 mt-3">
            <div className="col-sm-12 mt-3">
              <label>A Inscrição já foi paga!</label>
            </div>
          </div>
        )}
        <div className="btn-actions">
          <button
            className="btn btn-black mr-2"
            type="button"
            onClick={() => backClick()}
          >
            Voltar
          </button>
        </div>
      </Spinner>
    );
  }
}

export default withRouter(Payment);
